import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import Login from './pages/Auth/Login';
import RecoveryPassword from './pages/Auth/RecoveryPassword';
import ActivateAccount from './pages/Auth/ActivateAccount';
import MainTheme from './template/MainTheme';
import AppProvider from './contexts/AppContext';
import AuthProvider, { AuthContext } from './contexts/AuthContext';
import NotificationProvider from './contexts/NotificationContext';
import PrivateMiddleware from './routes/middleware/PrivateMiddleware';
import Pusher from 'pusher-js';
import useAuthService from './app/services/hooks/useAuthService';
import User from './pages/Users';
import Profile from './pages/Profile/EditProfile';
import PublicMiddleware from './routes/middleware/PublicMiddleware';
import Groups from './pages/Groups';
import Services from './pages/Services';
import BrandRegistration from './pages/BrandRegistration';
import BrandRegistrationApplication from './pages/BrandRegistrationApplication';
import BrandRegistrationStages from './pages/BrandRegistrationStages';
import BrandRegistrationEdit from './pages/BrandRegistrationEdit';
import PaymentSummary from './pages/PaymentSummary';
import PublicationPaymentSuccess from './pages/PublicationPaymentSuccess';
import PaymentRedirect from './pages/PaymentRedirect';
import InapiApplication from './pages/InapiApplication';
import ForeignExchange from './pages/ForeignExchange';
import SelectContractType from './pages/ContractDrafting/SelectContractType';
import ContractRequestForm from './pages/ContractDrafting/ContractRequestForm';
import ContractPreview from './pages/ContractDrafting/ContractPreview';
import PaymentSuccess from './pages/ContractDrafting/PaymentSuccess';
import MyContracts from './pages/ContractDrafting/MyContracts';
import ContractTypeList from './pages/Admin/ContractTypes/ContractTypeList';
import ContractTypeForm from './pages/Admin/ContractTypes/ContractTypeForm';
import ContractTypeConfig from './pages/Admin/ContractTypes/ContractTypeConfig';
import ServicePricingList from './pages/ServicePricing/ServicePricingList';
import ServicePricingForm from './pages/ServicePricing/ServicePricingForm';
import SimilarityAlerts from './pages/SimilarityAlerts';
import HolidayList from './pages/Holidays/HolidayList';
import HolidayForm from './pages/Holidays/HolidayForm';
import FAQ from './pages/FAQs';
import ChatDocuments from './pages/ChatDocuments';
import Chat from './pages/Chat';
import ChecklistsAdmin from './pages/ChecklistsAdmin';
import ChecklistForm from './pages/ChecklistsAdmin/ChecklistForm';
import Checklists from './pages/Checklists';
import ChecklistRespond from './pages/Checklists/ChecklistRespond';
import ChecklistResult from './pages/Checklists/ChecklistResult';
import MembershipPlanList from './pages/MembershipPlans/MembershipPlanList';
import MembershipPlanForm from './pages/MembershipPlans/MembershipPlanForm';
import MySubscription from './pages/MySubscription';
import SignContract from './pages/ContractDrafting/SignContract';
import SignPower from './pages/BrandRegistrationEdit/SignPower';
import RegisterLawyer from './pages/Auth/RegisterLawyer';
import AcceptInvitation from './pages/Auth/AcceptInvitation';
import { DataProcessingAgreementPage, PrivacyPage, TermsPage } from './pages/Legal';
import VerifyEmail from './pages/Auth/VerifyEmail';
import ClientInvitation from './pages/Organization/ClientInvitation';
import MyOrganization from './pages/Organization/MyOrganization';
import ClientList from './pages/Organization/Clients/ClientList';
import ClientDetail from './pages/Organization/Clients/ClientDetail';
import OrganizationList from './pages/Organization/Admin/OrganizationList';
import OrganizationDetail from './pages/Organization/Admin/OrganizationDetail';
import ScheduledJobs from './pages/Admin/ScheduledJobs';
import VideoCatalog from './pages/Videos/VideoCatalog';
import VideoDetail from './pages/Videos/VideoDetail';
import VideoManage from './pages/Videos/VideoManage';


// import { EndPoints } from './app/services/EndPoints';

export const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY || '', {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER
    // userAuthentication: {
    //     endpoint: EndPoints.AUTH.PUSHER_AUTH,
    //     transport: "ajax",
    //     params: {},
    //     headers: {},
    //   },
});

export const channel = pusher.subscribe('notifications');

function App() {
    // const { getRoles } = useAuthService();

    // const [roles, setRoles] = useState<string[]>([]);
    // const [company, setCompany] = useState<string>('');

    // useEffect(() => {
    //     const path = window.location.pathname;
    //     if (path != '/login' && path != '/recovery-password') {
    //         getRoles({
    //             onSuccess: (response) => {
    //                 setRoles(response.data.roles);
    //                 setCompany(response.data.company);
    //             }
    //         });
    //     }
    // }, []);

    return (
        <Router>
            <AuthProvider>
                <AppProvider>
                    <NotificationProvider> 
                        <Switch>
                            <Route path="/login">
                                <PublicMiddleware>
                                    <MainTheme showLayouts={false}>
                                        <Login />
                                    </MainTheme>
                                </PublicMiddleware>
                            </Route>
                            <Route path="/recovery-password">
                                <PublicMiddleware>
                                    <MainTheme showLayouts={false}>
                                        <RecoveryPassword />
                                    </MainTheme>
                                </PublicMiddleware>
                            </Route>
                            <Route path="/activate-account">
                                <PublicMiddleware>
                                    <MainTheme showLayouts={false}>
                                        <ActivateAccount />
                                    </MainTheme>
                                </PublicMiddleware>
                            </Route>
                            <Route path="/sign/:token">
                                <SignContract />
                            </Route>
                            {/* Firma del poder simple por enlace público: el solicitante
                                no necesita cuenta, igual que en la firma de contratos. */}
                            <Route path="/firmar-poder/:token">
                                <SignPower />
                            </Route>
                            {/* Registro self-service de abogados y estudios (público) */}
                            <Route path="/registro-abogados">
                                <MainTheme showLayouts={false}>
                                    <RegisterLawyer />
                                </MainTheme>
                            </Route>
                            {/* Activación de la cuenta con el enlace del correo */}
                            <Route path="/verificar-correo">
                                <VerifyEmail />
                            </Route>
                            {/* Invitación a la cartera de un estudio para quien ya tenía cuenta */}
                            <Route path="/invitacion-cartera/:token">
                                <ClientInvitation />
                            </Route>
                            {/* Términos y privacidad (públicos, versión preliminar en revisión legal) */}
                            <Route path="/terminos">
                                <TermsPage />
                            </Route>
                            <Route path="/privacidad">
                                <PrivacyPage />
                            </Route>
                            {/* Contrato de encargo de tratamiento de datos (estudios y abogados) */}
                            <Route path="/contrato-encargo">
                                <DataProcessingAgreementPage />
                            </Route>
                            {/* Invitación a un estudio: se acepta con la cuenta existente o creando una */}
                            <Route path="/invitacion-estudio/:token">
                                <MainTheme showLayouts={false}>
                                    <AcceptInvitation />
                                </MainTheme>
                            </Route>
                            <PrivateMiddleware>
                                <Switch>
                                    <Route exact path="/intranet">
                                        <MainTheme showLayouts={true}>
                                            <Services />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/users">
                                        <MainTheme showLayouts={true}>
                                            <User />
                                        </MainTheme>
                                    </Route>
                                    
                                    {/* <Route path="/intranet/notifications">
                                        <MainTheme showLayouts={true}>
                                            <Notifications />
                                        </MainTheme>
                                    </Route> */}
                                    
                                    <Route path="/intranet/roles">
                                        <MainTheme showLayouts={true}>
                                            <Groups />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/edit-profile">
                                        <MainTheme showLayouts={true}>
                                            <Profile />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/foreign-exchange">
                                        <MainTheme showLayouts={true}>
                                            <ForeignExchange />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/brand-registration">
                                        <MainTheme showLayouts={true}>
                                            <BrandRegistration />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/brand-registration/similarity-alerts">
                                        <MainTheme showLayouts={true}>
                                            <SimilarityAlerts />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/brand-registration/new">
                                        <MainTheme showLayouts={true}>
                                            <BrandRegistrationApplication />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/brand-registration/stages/:id">
                                        <MainTheme showLayouts={true}>
                                            <BrandRegistrationStages />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/brand-registration/edit/:id/step/:step">
                                        <MainTheme showLayouts={true}>
                                            <BrandRegistrationEdit />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/payment/brand-registration/summary/:verificationId">
                                        <MainTheme showLayouts={true}>
                                            <PaymentSummary />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/payment/publication-success/:publicationId">
                                        <MainTheme showLayouts={true}>
                                            <PublicationPaymentSuccess />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/payment/redirect">
                                        <MainTheme showLayouts={false}>
                                            <PaymentRedirect />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/inapi-application">
                                        <MainTheme showLayouts={true}>
                                            <InapiApplication />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/contracts">
                                        <MainTheme showLayouts={true}>
                                            <MyContracts />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contracts/new">
                                        <MainTheme showLayouts={true}>
                                            <SelectContractType />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contracts/:id/form">
                                        <MainTheme showLayouts={true}>
                                            <ContractRequestForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contracts/:id/preview">
                                        <MainTheme showLayouts={true}>
                                            <ContractPreview />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contracts/:id/payment-success">
                                        <MainTheme showLayouts={true}>
                                            <PaymentSuccess />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/contract-types">
                                        <MainTheme showLayouts={true}>
                                            <ContractTypeList />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contract-types/create">
                                        <MainTheme showLayouts={true}>
                                            <ContractTypeForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contract-types/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <ContractTypeForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/contract-types/:id/config">
                                        <MainTheme showLayouts={true}>
                                            <ContractTypeConfig />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/service-pricing">
                                        <MainTheme showLayouts={true}>
                                            <ServicePricingList />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/service-pricing/create">
                                        <MainTheme showLayouts={true}>
                                            <ServicePricingForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/service-pricing/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <ServicePricingForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/holidays">
                                        <MainTheme showLayouts={true}>
                                            <HolidayList />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/holidays/create">
                                        <MainTheme showLayouts={true}>
                                            <HolidayForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/holidays/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <HolidayForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/faqs">
                                        <MainTheme showLayouts={true}>
                                            <FAQ />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/chat-documents">
                                        <MainTheme showLayouts={true}>
                                            <ChatDocuments />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/chat">
                                        <MainTheme showLayouts={true}>
                                            <Chat />
                                        </MainTheme>
                                    </Route>
                                    
                                    {/* Checklists Admin */}
                                    <Route exact path="/intranet/checklists-admin">
                                        <MainTheme showLayouts={true}>
                                            <ChecklistsAdmin />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/checklists-admin/create">
                                        <MainTheme showLayouts={true}>
                                            <ChecklistForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/checklists-admin/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <ChecklistForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    {/* Checklists Usuario */}
                                    <Route exact path="/intranet/checklists">
                                        <MainTheme showLayouts={true}>
                                            <Checklists />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/checklists/:id/respond">
                                        <MainTheme showLayouts={true}>
                                            <ChecklistRespond />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/checklists/result/:id">
                                        <MainTheme showLayouts={true}>
                                            <ChecklistResult />
                                        </MainTheme>
                                    </Route>
                                    
                                    {/* Mi Suscripción (Cliente) */}
                                    <Route exact path="/intranet/my-subscription">
                                        <MainTheme showLayouts={true}>
                                            <MySubscription />
                                        </MainTheme>
                                    </Route>
                                    
                                    {/* Planes de Membresía (Admin) */}
                                    <Route exact path="/intranet/membership-plans">
                                        <MainTheme showLayouts={true}>
                                            <MembershipPlanList />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route exact path="/intranet/membership-plans/create">
                                        <MainTheme showLayouts={true}>
                                            <MembershipPlanForm />
                                        </MainTheme>
                                    </Route>
                                    
                                    <Route path="/intranet/membership-plans/:id/edit">
                                        <MainTheme showLayouts={true}>
                                            <MembershipPlanForm />
                                        </MainTheme>
                                    </Route>

                                    {/* Estudios y abogados independientes */}
                                    <Route path="/intranet/my-organization">
                                        <MainTheme showLayouts={true}>
                                            <MyOrganization />
                                        </MainTheme>
                                    </Route>
                                    <Route exact path="/intranet/clients">
                                        <MainTheme showLayouts={true}>
                                            <ClientList />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/intranet/clients/:id">
                                        <MainTheme showLayouts={true}>
                                            <ClientDetail />
                                        </MainTheme>
                                    </Route>

                                    {/* Panel SaaS de Monere */}
                                    <Route exact path="/intranet/organizations">
                                        <MainTheme showLayouts={true}>
                                            <OrganizationList />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/intranet/organizations/:id">
                                        <MainTheme showLayouts={true}>
                                            <OrganizationDetail />
                                        </MainTheme>
                                    </Route>
                                    {/* Programador de tareas (solo equipo Monere; el backend responde 403 al resto) */}
                                    <Route path="/intranet/scheduler">
                                        <MainTheme showLayouts={true}>
                                            <ScheduledJobs />
                                        </MainTheme>
                                    </Route>

                                    {/* Videos */}
                                    <Route exact path="/intranet/videos">
                                        <MainTheme showLayouts={true}>
                                            <VideoCatalog />
                                        </MainTheme>
                                    </Route>
                                    <Route exact path="/intranet/videos/manage">
                                        <MainTheme showLayouts={true}>
                                            <VideoManage />
                                        </MainTheme>
                                    </Route>
                                    <Route path="/intranet/videos/:id">
                                        <MainTheme showLayouts={true}>
                                            <VideoDetail />
                                        </MainTheme>
                                    </Route>
                                </Switch>
                            </PrivateMiddleware>
                        </Switch>
                        </NotificationProvider>
                </AppProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
